import React from 'react';
import { EducationDesignPreview } from '../education/EducationDesignExperiment';
import CoursePageV2 from './CoursePageV2';

/** Editable review copy. Never enrolls visitors in the live design/name tests. */
export default function BootcampV2Review(): React.ReactElement {
  return (
    <div className="bootcamp-v2 education-design-experiment" data-bootcamp-version="v2">
      <EducationDesignPreview variant="control">
        <CoursePageV2 />
      </EducationDesignPreview>
    </div>
  );
}
